import React, { useState, useCallback, MouseEvent } from 'react';
import { IconButton, Badge, Popover, Box, Typography, Button  } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';

export interface Notification {
    id: string | number;
    message: string;
    read?: boolean;
    title?: string;
    enabledButton?: boolean;
    buttonName?: string;
    redirect?: string;
}

export interface NotificationBellProps {
    notifications?: Notification[];
}

const NotificationBell: React.FC<NotificationBellProps> = React.memo(({ notifications = [] }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const unreadCount = notifications.filter((n) => !n.read).length;

    const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    return (
        <>
        <IconButton
            edge="end"
            size="small"
            color="inherit"
            onClick={handleOpen}
        >
            <Badge
                badgeContent={unreadCount > 0 ? '!' : null}
                color="error"
                >
                <NotificationsIcon />
            </Badge>
        </IconButton>

        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { width: 350, p: 0 } }}
            disableScrollLock
            >
            <Box display="flex" alignItems="center" justifyContent="space-between" p={1}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Notifications
                </Typography>
                <IconButton size="small" onClick={handleClose}>
                <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <Box p={1}>
                {notifications.length === 0 ? (
                <Typography variant="body2">No notifications</Typography>
                ) : (
                notifications.map(({ id, message, buttonName,enabledButton, redirect }) => (
                    <Box key={id} mb={2}>
                    <Typography variant="body2" mb={1}>
                        {message}
                    </Typography>

                    {enabledButton &&
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => {
                                handleClose();
                                window.location.href = redirect;
                            }}
                            sx={{ mt: 0 }}
                            >
                            {buttonName}
                        </Button>
                    }
                    
                    </Box>
                ))
                )}
            </Box>
        </Popover>
        </>
    );
});

export default NotificationBell;